import React from "react";
import { useTranslate } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import {
  useMediaQuery,
  Grid,
  Button,
  Avatar,
  Badge,
  Icon,
  Menu,
  MenuItem,
} from "@material-ui/core";
//import ExportIcon from "assets/Export.svg";
//import Dis_ExportIcon from "assets/Dis_Export.svg";
import PaymentIcon from "assets/Payment.svg";
import Dis_PaymentIcon from "assets/Dis_Payment.svg";
import PrintChequeIcon from "assets/PrintCheque.svg";
import Dis_PrintChequeIcon from "assets/Dis_PrintCheque.svg";
import PrintWhtIcon from "assets/PrintWHT.svg";
import Dis_PrintWhtIcon from "assets/Dis_PrintWHT.svg";
import SnackbarUtils from "utils/SnackbarUtils";
import { FcCalculator } from "react-icons/fc";
import OCRIcon from "assets/aiocr-bluepurple-256.png";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  layout: {
    padding: theme.spacing(1),
    marginBottom: 12,
  },
  button: {
    fontWeight: 400,
    textTransform: "none",
    height: 60, // setting height/width is optional
  },
  label: {
    // Aligns the content of the button vertically.
    flexDirection: "column",
    whiteSpace: "pre",
    lineHeight: 1.3,
  },
  small: {
    width: 18,
    height: 18,
    margin: 1,
  },
  circularProgress: {
    marginLeft: 0,
    marginRight: theme.spacing(1),
  },
  aiNotificationBadge: {
    backgroundColor: theme.palette.error.main,
    animation: "$aiNotificationPulse 1.5s ease-out infinite",
  },
  "@keyframes aiNotificationPulse": {
    "0%": { boxShadow: `0 0 0 0 ${theme.palette.error.main}` },
    "70%": { boxShadow: "0 0 0 6px rgba(0, 0, 0, 0)" },
    "100%": { boxShadow: "0 0 0 0 rgba(0, 0, 0, 0)" },
  },
}));

const ActionMenu = (props) => {
  const classes = useStyles();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const translate = useTranslate();
  const { menuControl, justify, permission, size } = props;

  const SwitchBtn = ({ name, dis, notification }) => {
    let translatedName = translate(`ra.actionMenu.${name}`);
    switch (name) {
      case "Back":
        return (
          <>
            <Icon className="material-icons-outlined">arrow_back</Icon>
            {translatedName}
          </>
        );
      case "Add":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              insert_drive_file
            </Icon>
            {translatedName}
          </>
        );
      case "Add Child":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              add
            </Icon>
            {translate("ra.field.Add Child")}
          </>
        );
      case "Edit":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              edit
            </Icon>
            {translatedName}
          </>
        );
      case "Delete":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              delete
            </Icon>
            {translatedName}
          </>
        );
      case "Deactivate":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              toggle_off
            </Icon>
            {translatedName}
          </>
        );
      case "Move":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              drive_file_move
            </Icon>
            {translate("ra.field.Move")}
          </>
        );
      case "Void":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              delete
            </Icon>
            {translatedName}
          </>
        );
      case "Copy":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              file_copy
            </Icon>
            {translatedName}
          </>
        );
      case "Copy To":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              file_copy
            </Icon>
            Copy To
          </>
        );
      case "Pre-Asset":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              description
            </Icon>
            Pre-Asset
          </>
        );
      case "Template":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              description
            </Icon>
            {translatedName}
          </>
        );
      case "Disposal":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              description
            </Icon>
            {translatedName}
          </>
        );
      case "Print":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              print
            </Icon>
            {translatedName}
          </>
        );
      case "Print Voucher":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              print
            </Icon>
            {name}
          </>
        );
      case "Print Form":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              print
            </Icon>
            {name}
          </>
        );
      case "Print Report":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              description
            </Icon>
            {name}
          </>
        );
      case "Export":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              cloud_download
            </Icon>
            {name}
          </>
        );
      case "Print BarCode":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              print
            </Icon>
            {name}
          </>
        );
      case "Print Cheque":
        return (
          <>
            <Avatar
              variant="square"
              className={classes.small}
              alt="Print Cheque"
              src={!dis ? PrintChequeIcon : Dis_PrintChequeIcon}
            />
            {name}
          </>
        );
      case "Print WHT":
        return (
          <>
            <Avatar
              variant="square"
              className={classes.small}
              alt="Print Wht"
              src={!dis ? PrintWhtIcon : Dis_PrintWhtIcon}
            />
            {name}
          </>
        );
      case "View Account Summary":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              description
            </Icon>
            View Account Summary
          </>
        );
      case "Payment":
        return (
          <>
            <Avatar
              variant="square"
              className={classes.small}
              alt="Payment"
              src={!dis ? PaymentIcon : Dis_PaymentIcon}
            />
            {translatedName}
          </>
        );
      case "Receipt":
        return (
          <>
            <Avatar
              variant="square"
              className={classes.small}
              alt="Receipt"
              src={!dis ? PaymentIcon : Dis_PaymentIcon}
            />
            {translatedName}
          </>
        );
      case "Settings":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              settings
            </Icon>
            {name}
          </>
        );
      case "Send Email":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              mail
            </Icon>
            {name}
          </>
        );
      case "Activity Log":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              history
            </Icon>
            {name}
          </>
        );
      case "Allocate Tax":
        return (
          <>
            <FcCalculator size={22} color={!dis ? "primary" : "disabled"} />
            Allocate
            <br />
            Tax
          </>
        );
      case "AI":
        return (
          <>
            <Badge
              variant="dot"
              overlap="circular"
              invisible={!notification}
              classes={{ badge: classes.aiNotificationBadge }}
            >
              <img style={{ height: 22, padding: 0 }} src={OCRIcon} alt="AI" />
            </Badge>
            AI
          </>
        );
      case "Export Template":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              cloud_download
            </Icon>
            {translatedName}
          </>
        );
      case "Import Template":
        return (
          <>
            <Icon
              className="material-icons-outlined"
              color={!dis ? "primary" : "disabled"}
              fontSize={"medium"}
            >
              cloud_upload
            </Icon>
            {translatedName}
          </>
        );
      //no default
    }
  };

  const CheckPermission = (name, fnc) => {
    const textTranslate = translate("ra.permission.denied");
    switch (name) {
      case "Add":
      case "Copy":
      case "Template":
      case "Add Child":
        if (permission["Add"]) {
          return fnc();
        } else {
          SnackbarUtils.error(textTranslate);
          return false;
        }
      case "Edit":
      case "Copy To":
      case "Move":
      case "Deactivate":
        if (permission["Update"]) {
          return fnc();
        } else {
          SnackbarUtils.error(textTranslate);
          return false;
        }
      case "Void":
      case "Delete":
        if (permission["Delete"]) {
          return fnc();
        } else {
          SnackbarUtils.error(textTranslate);
          return false;
        }
      case "Print":
        if (permission["View"]) {
          return fnc ? fnc() : null;
        } else {
          SnackbarUtils.error(textTranslate);
          return false;
        }
      default:
        if (fnc) {
          return fnc ? fnc() : null;
        } else {
          return null;
        }
    }
  };

  const DropdownButton = ({ element }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <>
        <Button
          classes={{ root: classes.button, label: classes.label }}
          disabled={element.disabled}
          onClick={handleClick}
        >
          <Icon
            className="material-icons-outlined"
            color={!element.disabled ? "primary" : "disabled"}
            fontSize="medium"
          >
            {element.icon || "description"}
          </Icon>
          {translate(`ra.actionMenu.${element.name}`) || element.name}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {element.items.map((item) => (
            <MenuItem
              key={item.name}
              disabled={item.disabled}
              onClick={() => {
                handleClose();
                if (permission) {
                  CheckPermission(item.name, item.fnc);
                } else {
                  item.fnc();
                }
              }}
            >
              {translate(`ra.actionMenu.${item.name}`) || item.name}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  };

  if (isXSmall) {
    return null;
  }

  return (
    <Grid item xs={size ? "auto" : 12}>
      <Grid
        container
        justifyContent={justify ? justify : "flex-end"}
        spacing={1}
      >
        {menuControl
          ? menuControl.map((element) => (
              <Grid
                item
                key={element.name}
                style={
                  element.hide
                    ? { display: "none", flex: element.name === "Back" ? 1 : 0 }
                    : { flex: element.name === "Back" ? 1 : 0 }
                }
              >
                {element.items ? (
                  <DropdownButton element={element} />
                ) : (
                  <Button
                    classes={{ root: classes.button, label: classes.label }}
                    disabled={
                      element.name !== "Back" ? element.disabled : false
                    }
                    onClick={() => {
                      if (permission) {
                        CheckPermission(element.name, element.fnc);
                      } else {
                        element.fnc();
                      }
                    }}
                    style={element.hide ? { display: "none" } : {}}
                  >
                    <SwitchBtn
                      name={element.name}
                      dis={element.disabled}
                      notification={element.notification}
                    />
                  </Button>
                )}
              </Grid>
            ))
          : ""}
      </Grid>
    </Grid>
  );
};

export default ActionMenu;
